import '~interface/polyfills'
import Vue from 'vue'
// import '~vendor/svgxuse'
import './configs'
import '~interface/lazyloading'
import Headroom from 'headroom.js'
import PortalVue from 'portal-vue'
import {
  Banner,
  Collapse,
  CollapseItem,
  Icon,
  NavigationMenu,
  Tabs,
  SearchInput,
  SearchResults,
  SocialShare,
  Tooltip,
  TabPane,
  ZoomContainer,
} from 'zv-components'
import * as LayoutComponents from '~layouts'

import { router } from './routes'

import(/* webpackChunkName: "object-fit-images" */'~vendor/object-fit-images')
import(/* webpackChunkName: "interface-imgix" */'~interface/imgix')
import(/* webpackChunkName: "interface-imgix" */'~interface/scrollTo')
import(/* webpackChunkName: "zv-instance-props" */'~interface/instanceProps')

const CookieConsent = () => import(/* webpackChunkName: "vue-cookie-consent" */'./layouts/CookieConsent')
const ContentSlideshow = () => import(/* webpackChunkName: "ContentSlideshow" */'./components/ContentSlideshow')
const PostSlideshow = () => import(/* webpackChunkName: "PostSlideshow" */'./components/PostSlideshow')
const ScriptEmbed = () => import(/* webpackChunkName: "ScriptEmbed" */'./components/ScriptEmbed')

Vue.prototype.$headroom = Headroom
Vue.debug = process.env.NODE_ENV !== 'production'

Vue.use(PortalVue)

const app = new Vue({
  router,
  components: {
    ...LayoutComponents,
    Banner,
    Collapse,
    CollapseItem,
    Icon,
    NavigationMenu,
    SearchInput,
    SearchResults,
    SocialShare,
    Tabs,
    Tooltip,
    TabPane,
    ZoomContainer,
    ContentSlideshow,
    CookieConsent,
    PostSlideshow,
    ScriptEmbed,
  },

  data () {
    return {
      bannerKeepOpen: false,
      bannerDefaultPane: false,
      searchQuery: '',
    }
  },

  computed: {
    showSearchResults: function () {
      return this.searchQuery.length > 0
    },
  },

  mounted () {
    this.$on('menuChange', (isOpen) => {
      if (isOpen) {
        document.body.classList.add('no-scroll')
      } else {
        document.body.classList.remove('no-scroll')
      }
    })

    this.mq = window.matchMedia('(max-width: 767px)')
    this.mq.addListener(this.onMatchMedia)
    this.onMatchMedia(this.mq)
  },

  beforeDestroy () {
    this.mq && this.mq.removeListener(this.onMatchMedia)
  },

  methods: {
    onMatchMedia (mq) {
      this.bannerDefaultPane = !mq.matches ? globalConfigs.defaultMenuPane : null
      this.bannerKeepOpen = !mq.matches
    },
    onMenuStateChange (active) {
      if (!active) {
        this.searchQuery = ''
      }

      this.$emit('menuChange', active)
    },
    generateEventUrlBySlug (slug) {
      return globalConfigs.events.home + slug
    },
  },
}).$mount('.app')

export default app
